import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export const bookingService = {
  // Create a new booking
  async createBooking(bookingData) {
    // Format phone number to contain only digits
    const phoneDigits = bookingData.phone.replace(/\D/g, '');

    const response = await httpClient.post(API_ENDPOINTS.BOOKINGS.CREATE, {
      name: bookingData.name.trim(),
      email: bookingData.email.trim(),
      phone: phoneDigits,
      dateOfBirth: bookingData.dateOfBirth,
      timeOfBirth: bookingData.timeOfBirth || null,
      placeOfBirth: bookingData.placeOfBirth.trim(),
      message: bookingData.message ? bookingData.message.trim() : '',
      consultationDate: bookingData.consultationDate,
      consultationTimeSlot: bookingData.consultationTimeSlot
    });

    return response;
  },

  // Get all bookings for current user
  async getUserBookings() {
    const response = await httpClient.get(API_ENDPOINTS.BOOKINGS.USER_BOOKINGS);
    return response;
  },

  // Get booking by ID
  async getBookingById(id) {
    const response = await httpClient.get(API_ENDPOINTS.BOOKINGS.GET_BY_ID(id));
    return response;
  },

  // Cancel booking
  async cancelBooking(id) {
    const response = await httpClient.put(API_ENDPOINTS.BOOKINGS.CANCEL(id));
    return response;
  },

  // Get all bookings (admin only)
  async getAllBookings() {
    const response = await httpClient.get(API_ENDPOINTS.BOOKINGS.ALL);
    return response;
  },

  // Get booked time slots for a given date (public)
  async getBookedSlots(date) {
    const response = await httpClient.get(API_ENDPOINTS.BOOKINGS.BOOKED_SLOTS(date));
    return response.bookedSlots || [];
  }
};

export default bookingService;
